import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'

@Component({
  template: ` {{ note }} `,
  styles: [
    `
      :host {
        display: block;
        white-space: pre-wrap;
        padding: 2em;
      }
    `,
  ],
  standalone: false,
})
export class ServiceRecordNoteDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public note: string) {}
}
